{
  "_comment": "T-07 (conversion audit) — the ONE plan config. Consumed by UpgradePage (auth.js), Settings->Billing (settings.js), and diffed against the marketing pricing section by scripts/check-plan-parity.js. Feature lists follow the marketing page per the audit's reconciliation rule; conflicts the owner still needs to adjudicate are listed under _todoOwner. Prices and features here are DISPLAY copy only — entitlement enforcement lives in server/middleware/tier.js.",
  "_todoOwner": [
    "Founder card: marketing says '1 Brand Brain'; the app previously advertised '5 Brand Brains, 3 team seats' on the Upgrade page and Settings->Billing. Marketing version kept as placeholder — confirm which is the real Founder entitlement.",
    "Refund wording: app previously said '7-day money-back guarantee' (Upgrade page) while Terms say case-by-case. Guarantee line removed pending the /refunds policy (T-14).",
    "'6 platforms' feature wording carried over from marketing verbatim; T-12 will reconcile platform claims against what is actually live."
  ],
  "annualSaveLabel": "Save 20%",
  "trialNote": "All plans include a 7-day free trial of Pro — your first 25 posts generated on us, no credit card, no API key. Cancel anytime.",
  "plans": [
    {
      "id": "starter",
      "name": "Starter",
      "monthly": 19,
      "annual": 15,
      "desc": "For creators getting started.",
      "features": ["1 Brand Brain", "100 posts / month", "6 platforms (text)", "Full-fidelity previews", "5 active campaigns"]
    },
    {
      "id": "pro",
      "name": "Pro",
      "monthly": 49,
      "annual": 39,
      "popular": true,
      "desc": "For creators serious about growth.",
      "features": ["1 Brand Brain", "500 posts / month", "6 platforms + video upload", "20 campaigns", "Priority AI models"]
    },
    {
      "id": "founder",
      "name": "Founder",
      "monthly": 99,
      "annual": 79,
      "desc": "For operators who want the full arsenal.",
      "features": ["1 Brand Brain", "Unlimited posts", "All 6 platforms + blog + video", "Premium AI models", "Full analytics + export"]
    },
    {
      "id": "agency",
      "name": "Agency",
      "monthly": 199,
      "annual": 159,
      "desc": "For agencies managing multiple brands.",
      "features": ["25 Brand Brains", "Unlimited posts", "All 6 platforms + blog + video", "10 team seats included", "Content approvals + roles", "200 GB video storage"]
    }
  ]
}
